import { UserGroupResponse } from '@/modules/common/types/dto/user-group-response';
import { UserGroup } from '@/modules/common/types/user-group';

/**
 * Maps UserGroupResponse DTO to UserGroup domain model
 */
export const mapUserGroupFromResponse = (response: UserGroupResponse): UserGroup => {
  return {
    id: response.id,
    name: response.name,
    isDefault: response.isDefault,
  };
};

/**
 * Maps array of UserGroupResponse DTOs to UserGroup domain models
 */
export const mapUserGroupsFromResponse = (responses: UserGroupResponse[]): UserGroup[] => {
  return responses.map(mapUserGroupFromResponse);
};
